"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8618],{

/***/ 83689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Thumbnail; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31157);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49613);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54444);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23502);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);














var Thumbnail = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].img.withConfig({ displayName: "Hero__Thumbnail", componentId: "sc-1sz0hnr-0" })(["position:static;width:100%;object-fit:contain;"]);






























var Hero = function Hero(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
      as: _components__WEBPACK_IMPORTED_MODULE_4__/* .HeroBackground */ .Mn,
      whiteBackground: props.whiteBackground,
      backgroundImage: props.backgroundImage,
      backdrop: props.heroSection,
      flexDirection: props.reverseColumns ? 'row-reverse' : 'row',
      alignItems: "stretch",
      flexWrap: "wrap",
      className: props.className,
      px: props.px,
      py: props.py, children: [

      (props.video || props.image || props.category) && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { as: _components__WEBPACK_IMPORTED_MODULE_4__/* .VideoWrapper */ .U1, width: [1, 1, 1 / 2], children: [
        props.image ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Thumbnail, {
          src: props.image,
          srcSet: props.imageSrcSet,
          sizes: props.imageSizes }) :

        null,
        props.video ? props.video : null] }),


      (props.hasOwnProperty('title') ||
      props.hasOwnProperty('description')) && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: _components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapper */ .OP,
        width: [1, 1, 1 / 2],
        p: props.heroSection ? null : ['10px', '10px', '40px'],
        py: props.heroSection ? ['12%', '12%', '18%'] : null,
        pl: !props.reverseColumns ? null : [0, 0, 0],
        transparentColor: props.transparentColor,
        alignItems: "center", children: /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
          as: _components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapperInner */ .z5,
          flexWrap: "wrap",
          flexDirection: "column",
          justifyContent: props.vAlignment ? props.vAlignment : "center", children: [

          props.category && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .CategoryTitle */ .gI, { children: props.category }),
          props.title && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, { dark: !!props.transparentColor || props.darkTheme, children:
            props.title }),


          props.checkTags && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { flexWrap: "nowrap", alignItems: "flex-start", mb: "20px", children:
            props.checkTags.map(function (tag, index) {return /*#__PURE__*/(
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                  as: _components__WEBPACK_IMPORTED_MODULE_4__/* .SubscriptionTag */ .Z7,
                  mr: 20,
                  alignItems: "center",
                  justifyContent: "center",

                  dark: !!props.transparentColor, children: [/*#__PURE__*/

                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: "ygb-icon-checkmark",
                    fontSize: "14px",
                    style: { marginRight: '10px' } }),

                  tag] }, index));}) }),





          props.subtitle ?
          props.noSubtitleWrapper ?
          props.subtitle : /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .SubTitle */ .DK, { dark: !!props.transparentColor || props.darkTheme, children:
            props.subtitle }) :


          null,
          props.description && typeof props.description === 'string' ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Paragraph */ .nv, {
            className: "Hero--Description",
            dark: !!props.transparentColor || props.darkTheme, children:

            props.description }) :


          props.description,

          props.actions && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
            as: _components__WEBPACK_IMPORTED_MODULE_4__/* .ActionsWrapper */ .T0,
            flexWrap: "nowrap",
            alignItems: "center",
            justifyContent: "flex-start", children:

            props.actions.map(function (action, index) {
              if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(action)) {
                return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(action, { key: index });
              } else {
                var button = action;
                return /*#__PURE__*/(
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {

                    appearance: button.theme ? button.theme : null,
                    onClick: button.onClick,
                    href: button.href, children:

                    button.name }, index));


              }
            }) }),


          props.disclaimer ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .Disclaimer */ .em, { dark: !!props.transparentColor || props.darkTheme, children:
            props.disclaimer }) :

          null] }) })] }));





};
/* harmony default export */ __webpack_exports__["Z"] = (Hero);

/***/ }),

/***/ 23502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ SubTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Mn": function() { return /* binding */ HeroBackground; },
/* harmony export */   "OP": function() { return /* binding */ TextWrapper; },
/* harmony export */   "T0": function() { return /* binding */ ActionsWrapper; },
/* harmony export */   "U1": function() { return /* binding */ VideoWrapper; },
/* harmony export */   "Z7": function() { return /* binding */ SubscriptionTag; },
/* harmony export */   "em": function() { return /* binding */ Disclaimer; },
/* harmony export */   "gI": function() { return /* binding */ CategoryTitle; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; },
/* harmony export */   "z5": function() { return /* binding */ TextWrapperInner; }
/* harmony export */ });
/* unused harmony export HeroCaption */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);


var VideoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__VideoWrapper", componentId: "sc-1qhd2hj-0" })(["& > *{height:100%;display:flex;align-items:center;.video-js.video-justify-content.video-js{height:100%;@media (min-width:", "px){padding-top:0;}}.vjs-poster{background-size:cover;}}"],







function (props) {return props.theme.viewports.tablet;});









var HeroBackground = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__HeroBackground", componentId: "sc-1qhd2hj-1" })(["border-radius:3px;overflow:hidden;background-color:", ";background-image:", ";background-repeat:no-repeat;background-size:cover;background-position:top center;", ";"],






function (props) {return props.whiteBackground ? 'white' : null;},
function (props) {return (
    props.backgroundImage ? "url(".concat(props.backgroundImage, ")") : null);},



function (_ref) {var backdrop = _ref.backdrop;return (
    backdrop && "\n      &:before {\n        content: '';\n        display: block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: rgba(64, 64, 64, 0.3);\n      }\n    ");});














var TextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__TextWrapper", componentId: "sc-1qhd2hj-2" })(["background-color:transparent;z-index:11;background-color:", ";"],


function (_ref2) {var transparentColor = _ref2.transparentColor;return (
    transparentColor ? transparentColor : null);});


var TextWrapperInner = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__TextWrapperInner", componentId: "sc-1qhd2hj-3" })(["height:100%;"]);



var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({ displayName: "components__Title", componentId: "sc-1qhd2hj-4" })(["margin:0;margin-bottom:20px;color:", ";font-size:34px;font-weight:bold;line-height:41px;"],


function (props) {return props.dark ? "#fff" : "#253238";});





var SubTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({ displayName: "components__SubTitle", componentId: "sc-1qhd2hj-5" })(["margin:0;margin-bottom:20px;color:", ";font-size:28px;font-weight:300;line-height:36px;:empty{display:none;}"],


function (props) {return props.dark ? "#fff" : "#242424";});









var SubscriptionTag = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__SubscriptionTag", componentId: "sc-1qhd2hj-6" })(["position:relative;color:", ";color:", ";font-size:13px;font-weight:300;line-height:23px;i{&:before{color:", ";}}"],

function (props) {return props.theme.colors.neutrals.black;},
function (props) {return props.dark && "#fff";},






function (props) {return props.theme.colors.primary['pink-1'];});




var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__Paragraph", componentId: "sc-1qhd2hj-7" })(["font-size:14px;color:", ";line-height:26px;margin:0 0 20px 0;p{margin:0;}:empty{display:none;}"],

function (props) {return props.dark ? "#fff" : "#242424";});












var Disclaimer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({ displayName: "components__Disclaimer", componentId: "sc-1qhd2hj-8" })(["color:", ";font-size:12px;font-style:italic;line-height:23px;margin:0;margin-bottom:20px;:empty{display:none;}"],
function (props) {return props.dark ? "#fff" : "#242424";});











var ActionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__ActionsWrapper", componentId: "sc-1qhd2hj-9" })([":empty{display:none;}button{margin-right:10px;}"]);









var CategoryTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({ displayName: "components__CategoryTitle", componentId: "sc-1qhd2hj-10" })(["font-size:18px;font-weight:400;margin:0;"]);





var HeroCaption = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "components__HeroCaption", componentId: "sc-1qhd2hj-11" })(["background-color:rgba(102,124,145,0.4);padding:11px 0;color:white;font-size:16px;font-weight:600;line-height:23px;width:100%;z-index:11;"]);

/***/ }),

/***/ 27352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "In": function() { return /* binding */ Bullets; },
  "PD": function() { return /* binding */ BulletsList; },
  "ZP": function() { return /* binding */ pricing_PricingSection; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/memoize.js
var memoize = __webpack_require__(88306);
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./components/Icon.tsx
var Icon = __webpack_require__(54444);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./components/templates/showcase/components.tsx
var components = __webpack_require__(24746);
// EXTERNAL MODULE: ./lib/contexts/UserProvider.tsx
var UserProvider = __webpack_require__(47493);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./ecosystems/pricing/PricingTrialCard.tsx





var PricingTrialCard = function PricingTrialCard(_ref) {var onPlanSelect = _ref.onPlanSelect;
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Grid/* Box */.xu, { px: [0, 10, 10], mb: [10, 10, 0], className: "SubscriptionBox--Card", children: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(components/* SubscriptionBox */.Iq, { className: "SubscriptionBox", children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(components/* SubscriptionBoxTitle */.A1, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.trial.title" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(components/* SubscriptionBoxPrice */.Lq, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.trial.price" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(components/* SubscriptionBoxBilled */.IQ, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.trial.body" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
          className: "Card--ApplyButton",
          appearance: "dark-blue",
          onClick: function onClick() {
            onPlanSelect();
          }, children: /*#__PURE__*/

          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.trial.button_text" }) })] }) }));




};

/* harmony default export */ var pricing_PricingTrialCard = (PricingTrialCard);
;// CONCATENATED MODULE: ./ecosystems/pricing/PricingSubscriptionCard.tsx







var SubscriptionBoxPriceWrapper = (0,styled_components_browser_esm["default"])(components/* SubscriptionBoxPriceWrapper */.cN).withConfig({ displayName: "PricingSubscriptionCard__SubscriptionBoxPriceWrapper", componentId: "sc-4haaxk-0" })(["flex-direction:row;align-items:center;"]);




var SUBSCRIPTION_OPTIONS = {
  12: {
    value: 'yearly',
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.annually.title" }),
    description: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.annually.body" }),
    cycle: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.annually.label" }) },

  3: {
    value: 'quarterly',
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.quarterly.title" }),
    description: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.quarterly.body" }),
    cycle: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.quarterly.label" }) },

  1: {
    value: 'monhtly',
    title: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.monthly.title" }),
    description: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.monthly.body" }),
    cycle: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.monthly.label" }) } };








var PricingSubscriptionCard = function PricingSubscriptionCard(_ref)



{var _subscription$discoun;var subscription = _ref.subscription,toHighlight = _ref.toHighlight,onPlanSelect = _ref.onPlanSelect;
  var highlight = toHighlight === subscription.subscriptionPlan;
  var text = SUBSCRIPTION_OPTIONS[subscription.months];
  var oldPrice;
  if (
  // if the susbcription has a discount we show the old price crossed
  subscription.discountedAmount &&
  subscription.discountedAmount !== subscription.amount)
  {
    oldPrice = /*#__PURE__*/
    (0,jsx_runtime.jsx)(components/* SubscriptionBoxOldPrice */.Zc, { children:
      subscription.amount + subscription.currency });


  }

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Grid/* Box */.xu, { px: [0, 10, 10], mb: [10, 10, 0], children: /*#__PURE__*/
      (0,jsx_runtime.jsxs)(components/* SubscriptionBox */.Iq, {
        className:
        'SubscriptionBox' + (highlight ? 'Card--HighlightedCard' : ''), children: [


        highlight ? /*#__PURE__*/
        (0,jsx_runtime.jsx)(components/* BestPriceLabel */.Vo, { children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.best_value" }) }) :

        null, /*#__PURE__*/
        (0,jsx_runtime.jsx)(components/* SubscriptionBoxTitle */.A1, { children: text.title }),
        oldPrice, /*#__PURE__*/
        (0,jsx_runtime.jsxs)(SubscriptionBoxPriceWrapper, { children: [/*#__PURE__*/
          (0,jsx_runtime.jsxs)(components/* SubscriptionBoxPrice */.Lq, { children: [(_subscription$discoun =
            subscription.discountedAmount) !== null && _subscription$discoun !== void 0 ? _subscription$discoun : subscription.amount, " ",

            subscription.currency] }), " / ",


          text.cycle] }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(components/* SubscriptionBoxBilled */.IQ, { children:
          subscription.shortDescription ||
          subscription.description ||
          text.description }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(buttons/* default */.ZP, {
          className: "Card--ApplyButton",
          appearance: "dark-blue",
          onClick: function onClick() {
            onPlanSelect(subscription.subscriptionName);
          }, children: /*#__PURE__*/

          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.plan.button_text" }) })] }) }, subscription.subscriptionPlan));




};

/* harmony default export */ var pricing_PricingSubscriptionCard = (PricingSubscriptionCard);
// EXTERNAL MODULE: ./lib/hooks/useFlags.tsx
var useFlags = __webpack_require__(55932);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(4338);
;// CONCATENATED MODULE: ./ecosystems/pricing/PricingSection.tsx
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,defineProperty/* default */.Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}
















var YearlyLink = (0,styled_components_browser_esm["default"])(Link/* Anchor */.ee).withConfig({ displayName: "PricingSection__YearlyLink", componentId: "sc-16u4u4b-0" })(["display:block;"]);



var findHighlightedSubscription = memoize_default()(
function (
subscriptions,
defaultHighlight)
{
  var promotion = subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.find(
  function (subscription) {return subscription.promotionName;});


  // we try to find promotion if not found we return default
  return (promotion === null || promotion === void 0 ? void 0 : promotion.subscriptionPlan) || defaultHighlight;
});


var PricingWrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "PricingSection__PricingWrapper", componentId: "sc-16u4u4b-1" })(["padding:50px 20px;background-color:#F0F5FB;", "{font-size:24px;color:#243240;}.SubscriptionBoxCard--HighlightedCard{", "{background-color:", ";}button{background-color:", ";}}@media (min-width:", "px){", "{font-size:34px}}"],



components/* SubscriptionTitle */.hI,





components/* BestPriceLabel */.Vo,
function (_ref) {var highlightColor = _ref.highlightColor,theme = _ref.theme;return (
    highlightColor || theme.colors.primary['blue-2']);},



function (_ref2) {var highlightColor = _ref2.highlightColor,theme = _ref2.theme;return (
    highlightColor || theme.colors.primary['blue-2']);},



function (props) {return props.theme.viewports.tablet;},
components/* SubscriptionTitle */.hI);





var CheckMark = (0,styled_components_browser_esm["default"])(Icon/* default */.Z).withConfig({ displayName: "PricingSection__CheckMark", componentId: "sc-16u4u4b-2" })([""]);

var bulletPoints = [/*#__PURE__*/
(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.bullets.option1" }, 1), /*#__PURE__*/
(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.bullets.option2" }, 2), /*#__PURE__*/
(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.bullets.option3" }, 3), /*#__PURE__*/
(0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.bullets.option4" }, 4)];


var BulletsList = (0,styled_components_browser_esm["default"])(Grid/* Flex */.kC).withConfig({ displayName: "PricingSection__BulletsList", componentId: "sc-16u4u4b-3" })(["", "{color:#242424;margin-right:20px;i[name=ygb-icon-checkmark]{font-size:16px;margin-right:8px;&:before{color:", ";}}}"],
components/* SubscriptionTag */.Z7,








function (_ref3) {var highlightColor = _ref3.highlightColor,theme = _ref3.theme;return (
    highlightColor || theme.colors.primary['blue-2']);});





var Bullets = function Bullets(_ref4) {var _ref4$bullets = _ref4.bullets,bullets = _ref4$bullets === void 0 ? bulletPoints : _ref4$bullets;
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(BulletsList, {
      flexWrap: "wrap",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "start",
      px: "20px",
      py: "8px", children:

      bullets.map(function (item, i) {return /*#__PURE__*/(
          (0,jsx_runtime.jsxs)(Grid/* Box */.xu, {

            as: components/* SubscriptionTag */.Z7,
            alignItems: 'center',
            justifyContent: 'center', children: [/*#__PURE__*/

            (0,jsx_runtime.jsx)(CheckMark, { name: "ygb-icon-checkmark" }),
            item] }, i));}) }));




};













var PricingSection = function PricingSection(props) {var _data$availableSubscr, _data$availableSubscr3, _data$availableSubscr4;
  var _props$id =









  props.id,id = _props$id === void 0 ? null : _props$id,_props$className = props.className,className = _props$className === void 0 ? '' : _props$className,_props$bullets = props.bullets,bullets = _props$bullets === void 0 ? bulletPoints : _props$bullets,_props$bestValue = props.bestValue,bestValue = _props$bestValue === void 0 ? 'yearly' : _props$bestValue,_props$promotionCode = props.promotionCode,promotionCode = _props$promotionCode === void 0 ? null : _props$promotionCode,_props$campaign = props.campaign,campaign = _props$campaign === void 0 ? null : _props$campaign,_props$highlightColor = props.highlightColor,highlightColor = _props$highlightColor === void 0 ? null : _props$highlightColor,_props$returnToPage = props.returnToPage,returnToPage = _props$returnToPage === void 0 ? null : _props$returnToPage,_props$handlePlanSele = props.handlePlanSelect,handlePlanSelect = _props$handlePlanSele === void 0 ? null : _props$handlePlanSele;
  var router = (0,next_router.useRouter)();
  var lang = (0,react.useContext)(languageContext/* default */.Z);
  var _useFlags = (0,useFlags/* default */.ZP)(),_useFlags2 = (0,slicedToArray/* default */.Z)(_useFlags, 1),flags = _useFlags2[0];
  var _useContext = (0,react.useContext)(UserProvider/* UserContext */.S),currentUser = _useContext[0],loading = _useContext[1].loading;
  var _usePricingSubscripti =


  (0,generated/* usePricingSubscriptionPlansQuery */.B_J)({
    variables: { code: promotionCode } }),data = _usePricingSubscripti.data,subscriptionLoading = _usePricingSubscripti.loading;


  // the tree diffing ALGO gets confused when we render a box & remove it on client
  // so we delay rendering the cards until user & subscription is loaded or its null
  if (
  !data ||
  subscriptionLoading ||
  loading && !(currentUser !== null && currentUser !== void 0 && currentUser.id) ||
  currentUser === undefined)
  {
    return null;
  }

  var toHighlight = findHighlightedSubscription(
  data === null || data === void 0 ? void 0 : (_data$availableSubscr = data.availableSubscriptionPlans) === null || _data$availableSubscr === void 0 ? void 0 : _data$availableSubscr.subscriptions,
  bestValue);


  var isUserLoggedIn = !!(currentUser !== null && currentUser !== void 0 && currentUser.id);
  var onPlanSelect = function onPlanSelect() {var _data$availableSubscr2;var paymentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var params = _objectSpread(_objectSpread(_objectSpread({
      paymentType: paymentType },

    returnToPage ? { to: returnToPage } : {}),

    campaign ? { campaign: campaign } : {}),

    data !== null && data !== void 0 && (_data$availableSubscr2 = data.availableSubscriptionPlans) !== null && _data$availableSubscr2 !== void 0 && _data$availableSubscr2.isCodeValid ?
    { code: promotionCode } :
    {});


    var pathname = "/".concat(lang, "/subscription/select");
    if (typeof handlePlanSelect === 'function') {
      handlePlanSelect(paymentType, {
        pathname: pathname,
        query: params });

    } else {
      router.push({
        pathname: pathname,
        query: params });

    }
  };

  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(PricingWrapper, {
      className: className,
      id: id,
      highlightColor: highlightColor, children: /*#__PURE__*/

      (0,jsx_runtime.jsxs)(Grid/* Container */.W2, { flexDirection: "column", children: [/*#__PURE__*/
        (0,jsx_runtime.jsx)(components/* SubscriptionTitle */.hI, { id: "subscription_section", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "pricing_section.title" }) }), /*#__PURE__*/

        (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { alignItems: "center", justifyContent: "center", children: /*#__PURE__*/
          (0,jsx_runtime.jsx)(Bullets, { bullets: bullets }) }), /*#__PURE__*/

        (0,jsx_runtime.jsxs)(components/* SubscriptionsWrapper */.H8, {
          alignItems: "center",
          justifyContent: "center",
          pt: 40,
          mx: "-10px", children: [

          !isUserLoggedIn ? /*#__PURE__*/
          (0,jsx_runtime.jsx)(pricing_PricingTrialCard, { onPlanSelect: onPlanSelect }) :
          null,

          data === null || data === void 0 ? void 0 : (_data$availableSubscr3 = data.availableSubscriptionPlans) === null || _data$availableSubscr3 === void 0 ? void 0 : (_data$availableSubscr4 = _data$availableSubscr3.subscriptions) === null || _data$availableSubscr4 === void 0 ? void 0 : _data$availableSubscr4.map(
          function (subscription) {
            if (subscription.promotionKind !== 'extra_global') {
              if (
              flags.yearly_campaign &&
              subscription.promotionKind === 'global' &&
              subscription.months === 12)
              {
                // bypass ts-type check
                subscription = Object.assign({}, subscription, {
                  description: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                    id: "pricing_section.yearly_offers_description",
                    components: [/*#__PURE__*/
                    (0,jsx_runtime.jsx)(YearlyLink, { href: "/".concat(lang, "/yearly"), children: "0" }, "0")] }) });






              }

              return /*#__PURE__*/(
                (0,jsx_runtime.jsx)(pricing_PricingSubscriptionCard, {

                  subscription: subscription,
                  toHighlight: toHighlight,
                  onPlanSelect: onPlanSelect }, subscription.subscriptionPlan));


            }

            return null;
          })] })] }) }));





};

/* harmony default export */ var pricing_PricingSection = (PricingSection);

/***/ })

}]);